import { useContext, useState } from "react";
import { Button, Dropdown } from "@paguelofacil/pf-components";

import { LangContext } from "../../containers/Layout";

import "../../assets/scss/layout.scss"

const SPANISH = "ES";
const ENGLISH = "EN";

export const SelectorLenguages = ({ setLang }) => {
    const langFromContext = useContext(LangContext)

    const [closeOnSelect, setCloseOnSelect] = useState(false);
    const [selectedOption, setSelectedOption] = useState(-1);

    return (
        <Dropdown
            variant="neutral-secondary"
            widthAuto
            className="language-select"
            label={langFromContext === SPANISH ? "ES" : "EN"}
            closeOnSelect={closeOnSelect}
            selectedOption={selectedOption}
            menuWidth="3rem"
        >
            {langFromContext === SPANISH && (
                <Button
                    className="dropdown-options"
                    handleClick={() => {
                        setCloseOnSelect(!closeOnSelect);
                        setSelectedOption(1);
                        setLang(ENGLISH)
                    }}
                    variant="transparent"
                    size="sm"
                >
                    EN
                </Button>
            )}
            {langFromContext === ENGLISH && (
                <Button
                    className="dropdown-options"
                    handleClick={() => {
                        setCloseOnSelect(!closeOnSelect);
                        setSelectedOption(2);
                        setLang(SPANISH)
                    }}
                    variant="transparent"
                    size="sm"
                >
                    ES
                </Button>
            )}
        </Dropdown>
    );
};
